var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owal-list-section__header",on:{"click":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('owal-list-row-accessory',{class:`${this.collapsed ? 'owal-list__accessory_collapsed' : 'owal-list__accessory'}`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }